import { takeLatest, call, put } from "redux-saga/effects";
import { CANDIDATE_SAVE_FOR_LATER_REQUEST } from "../../actionTypes";

import {
  candidateSaveForLaterSuccess,
  candidateSaveForLaterFailure,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* addCandidate(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/save_candidate", action.payload)
    );
    if (response.data.status) {
      yield put(candidateSaveForLaterSuccess(response.data));
    } else {
      yield put(candidateSaveForLaterFailure(response.data));
    }
  } catch (error) {
    yield put(
      candidateSaveForLaterFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* candidateSaveForLaterSaga() {
  yield takeLatest(CANDIDATE_SAVE_FOR_LATER_REQUEST, addCandidate);
}
export default candidateSaveForLaterSaga;
